import { PaginationStyled } from './Pagination.styles';
import { PaginationProps } from './types';

/**
 * Pagination component.
 */
export const Pagination = (props: PaginationProps) => (
  <PaginationStyled {...props} shape="rounded" variant="outlined" />
);
